import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { getElectricityPrepaidTransaction } from '~/api/electricity-prepaid';
import { getInvoices } from '~/api/invoices';

export default {
  methods: {
    /**
     * Check user maximum electric power
     * @command - [apicall] checkUserElectricMeter [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkUserElectricMeter(currentTrx = null) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        userElectricMeter: '[apiresponse] userElectricMeter<power> [/apiresponse]',
        checkUserElectricMeterError: '[apiresponse] checkUserElectricMeterError [/apiresponse]',
      };

      try {
        // Get invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        const { data: electricityPrepaidData } = await getElectricityPrepaidTransaction(this.$axios, {
          transactionId: invoiceTrx.id,
        });
        const { power } = electricityPrepaidData;
        const finalResponse = responses.userElectricMeter.replace('<power>', power);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkUserElectricMeterError);
        console.error('[ERROR] Something is wrong when trying to check user electric meter', error);
      }
    },
  },
};
